import { Observable } from 'rxjs';

import { UnitResult } from '../../../../error';
import { CancelGuardJobShiftsRequest } from './cancel-guard-job-shifts-request';

/**
 * Service for cancelling guard job shifts.
 *
 * This abstract class defines the contract for cancelling shifts for a job.
 * Implementations of this service handle the actual cancellation logic.
 */
export abstract class CancelJobShiftsService {
    /**
     * Cancels shifts for a job.
     *
     * @param request - The request containing the job ID and shift IDs to cancel
     * @returns An Observable that emits a UnitResult indicating success or failure
     */
    abstract cancelJobShifts(request: CancelGuardJobShiftsRequest): Observable<UnitResult<void>>;
}
